export enum RequestActivityRequestType {
  DataAccess = 'data-access-request',
  Export = 'export-request',
  Import = 'import-request'
}

export enum ReviewActivityActorType {
  User = 'user',
  System = 'system'
}

export enum ReviewActivityEventType {
  RequestSubmitted = 'request_submitted',
  AssigneeAdded = 'assignee_added',
  AssigneeChanged = 'assignee_changed',
  AssigneeRemoved = 'assignee_removed',
  LabelAdded = 'label_added',
  LabelRemoved = 'label_removed',
  RequestApproved = 'request_approved',
  RequestRejected = 'request_rejected',
  AppealSubmitted = 'appeal_submitted',
  AttestationRequested = 'attestation_requested',
  AttestationSubmitted = 'attestation_submitted',
  DataAccessShared = 'data_access_shared'
}

export enum ReviewActivityDecisionOutcome {
  Approved = 'approved',
  Rejected = 'rejected'
}

export enum ReviewActivitySharingOutcome {
  Shared = 'shared',
  Rejected = 'rejected'
}
